import { TRANSITION_IN } from "../constants/AnimationConstants";
import AppConstants from "../constants/AppConstants";
import _ from "lodash";

const PROPS_GALLERY = ["gallery", "gs"];
const PROPS_GRAPHIC = ["gs"];
const PROPS_ICON = ["c"];
const PROPS_IFRAME = [];
const PROPS_SIMPLE = ["bgcolor", "bC", "bW"];
const PROPS_SVG = [];
const PROPS_TEXT = ["style", "c", "lC", "lH", "lS", "size", "tA", "font", "styles", "over"];
const PROPS_VIDEO = [];

const PROPS_TRANSITION = [TRANSITION_IN];
const PROPS_EFFECTS = ["o", "border"];

const LAYOUT_SPECIFIC_PROPS = ["size", "lH", "lS"];

class ElementPropertyCopier {
  constructor(/** String **/ fromLayout, /** String **/ toLayout) {
    this.fromLayout = fromLayout;
    this.toLayout = toLayout;

    this.propModifierMap = {
      size: this._modifyFontSize,
    };

    this.typePropCache = {};
  }

  copy(/** Object **/ element) {
    //Don't do anything with states element
    if (AppConstants.ELEMENT_TYPE_STATES == element.type) {
      return element;
    }

    let props = [];

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        props = _.concat(arguments[i]);
      }
    } else {
      props = _.get(this.typePropCache, element.type, []);

      if (props.length == 0) {
        props = _.concat(props, PROPS_EFFECTS, PROPS_TRANSITION);

        switch (element.type) {
          case AppConstants.ELEMENT_TYPE_GALLERY:
            props = _.concat(props, PROPS_GALLERY);
            break;
          case AppConstants.ELEMENT_TYPE_GRAPHIC:
            props = _.concat(props, PROPS_GRAPHIC);
            break;
          case AppConstants.ELEMENT_TYPE_ICON:
            props = _.concat(props, PROPS_ICON);
            break;
          case AppConstants.ELEMENT_TYPE_IFRAME:
            props = _.concat(props, PROPS_IFRAME);
            break;
          case AppConstants.ELEMENT_TYPE_SIMPLE:
            props = _.concat(props, PROPS_SIMPLE);
            break;
          case AppConstants.ELEMENT_TYPE_SVG:
            props = _.concat(props, PROPS_SVG);
            break;
          case AppConstants.ELEMENT_TYPE_TEXT:
            props = _.concat(props, PROPS_TEXT);
            break;
          case AppConstants.ELEMENT_TYPE_VIDEO:
            props = _.concat(props, PROPS_VIDEO);
            break;
        }

        _.set(this.typePropCache, element.type, props);
      }
    }

    //make sure to clone all props so if they are modified it doesn't affect the other layout
    let toCopyProps = _.cloneDeep(_.pick(_.get(element, this.fromLayout), props));

    let hasLayoutSpecificProps = _.some(LAYOUT_SPECIFIC_PROPS, function (prop) {
      return _.has(toCopyProps, prop);
    });

    if (hasLayoutSpecificProps) {
      toCopyProps = this._modifyPropsForLayout(
        element,
        toCopyProps,
        LAYOUT_SPECIFIC_PROPS,
        this.propModifierMap,
        this.toLayout
      );
    }

    _.merge(_.get(element, this.toLayout), toCopyProps);

    return element;
  }

  _modifyPropsForLayout(
    /** Object **/ element,
    /** Object **/ allProps,
    /** Array **/ propNames,
    /** Object **/ modifierMap,
    /** String **/ toLayout
  ) {
    let props = _.pick(allProps, propNames);

    _.each(
      props,
      _.bind(function (value, key) {
        if (_.has(modifierMap, key)) {
          _.set(allProps, key, _.get(modifierMap, key)(value, toLayout, element));
        }
      }, this)
    );

    return allProps;
  }

  _modifyFontSize(value, toLayout, element) {
    switch (toLayout) {
      case AppConstants.LAYOUT_MOBILE:
        break;
      case AppConstants.LAYOUT_DESKTOP:
        break;
    }

    return value;
  }
}

export default ElementPropertyCopier;
export const ElementConstants = {
  PROPS_GRAPHIC,
  PROPS_GALLERY,
  PROPS_ICON,
  PROPS_IFRAME,
  PROPS_SIMPLE,
  PROPS_SVG,
  PROPS_TEXT,
  PROPS_VIDEO,
  PROPS_TRANSITION,
  PROPS_EFFECTS,
};
